import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../views/style/appShell.css";

const navItems = [
  { to: "/app/home", label: "Hlavní stránka", mobilePrimary: true },
  { to: "/app/vyhledani-firmy", label: "Vyhledání firmy", highlighted: true, mobilePrimary: true },
  { to: "/app/chatbot", label: "Chatbot", mobilePrimary: true },
  { to: "/app/oborove-statistiky", label: "Oborové statistiky" },
  { to: "/app/benchmark-obory", label: "Benchmark oborů" },
  { to: "/app/financni-analyza", label: "Finanční analýza PDF" },
  { to: "/app/profile", label: "Nastavení profilu" },
];

function AppShell() {
  const { user } = useAuth();

  return (
    <div className="app-shell">
      <aside className="app-shell__sidebar">
        <div className="app-shell__sidebar-header">

          <span className="app-shell__user">Uživatel: {user?.name || user?.email}</span>

          <span className="app-shell__credits">Kredity: {user?.credits ?? 0}</span>

        </div>
        <nav className="app-shell__nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [isActive ? "is-active" : "", item.mobilePrimary ? "app-shell__nav-item--mobile-primary" : ""]
                  .filter(Boolean)
                  .join(" ")
              }
            >
              {item.label}
              {item.highlighted ? <span className="app-shell__nav-star" aria-hidden="true">★</span> : null}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="app-shell__main">
        <Outlet />
      </main>
    </div>
  );
}

export default AppShell;
